import { app, store } from '../index';

export const gendropdownquery = (key, service, text, value) => {
  return app
    .service(service)
    .find()
    .then(results => {
      if (results.data) {
        results = results.data;
      }

      return results.map(result => {
        var newoption;
        if (Array.isArray(text)) {
          let droptext = text.map((textval, index) => {
            if (index > 0) {
              return ' - ' + result[textval];
            } else {
              return result[textval];
            }
          });
          newoption = {
            key: result[key],
            value: result[value],
            text: droptext
          };
        } else {
          newoption = {
            key: result[key],
            value: result[value],
            text: result[text]
          };
        }
        return newoption;
      });
    });
};
export const gendropdown = (key, text, value, array) => {
  return array.map(result => {
    let newoption = {
      key: result[key],
      value: result[value],
      text: result[text]
    };
    return newoption;
  });
};
export const genempdrop = emps => {
  return emps.map(emp => {
    return {
      key: emp.empnumber,
      text: emp.firstname + ' ' + emp.lastname,
      value: emp.empnumber
    };
  });
};
export const genwoddrop = wods => {
  if (wods && wods.length) {
    return wods.map(wod => {
      if (wod) {
        return {
          key: wod.workOrderNbr,
          text: wod.workOrderNbr + ' ' + wod.description,
          value: wod
        };
      }
    });
  }
};

export const custdrop = custs => {
  if (custs && custs.length) {
    return custs.map(cust => {
      if (cust) {
        return {
          key: cust.custnumber,
          text: cust.custname,
          value: cust
        };
      }
    });
  }
};
export const genwonumdrop = wods => {
  if (wods && wods.length) {
    return wods.map(wod => {
      if (wod) {
        return {
          key: wod.workOrderNbr,
          text: wod.workOrderNbr + ' ' + wod.description,
          value: wod.workOrderNbr
        };
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/gendropdown.js